<template>
  <div>
    <modals-container name="modal1" />
    <v-dialog/>
    <div class="class_add_top">
      <a onclick="history.go(-1)" class="back">返回</a>
    </div>
    <div style="padding: 0 10px;">
      <div class="highlight_title">
        {{form.name}} - 报名情况
      </div>
      <!--右侧内容-->
      <div class="gj_top_class" style="background: none;">
        <a @click="showBox" style="background: none; margin-right: 0; padding: 0;"><el-button type="info" size="mini" icon="el-icon-message">发送消息</el-button></a>
        <a @click="multiAudit(selected, {title: '批量拒绝', text: '确认拒绝吗？', msg: '已拒绝', state: '2'})" style="background: none; margin-right: 0; padding-left: 0;"><el-button :disabled="selected.length == '0'" type="danger" size="mini" icon="el-icon-my-disable">批量拒绝</el-button></a>
        <a @click="multiAudit(selected, {title: '批量确认', text: '确认通过吗？', msg: '已确认', state: '1'})" style="background: none; margin-right: 0; padding-left: 0;"><el-button :disabled="selected.length == '0'" type="success" size="mini" icon="el-icon-my-enable">批量确认</el-button></a>
      </div>
      <div class="gj_list" style="min-height: 600px;">
        <h5 class="none_ts" v-if="lists.length == 0">
          <img src="@/assets/images/none_data.jpg" alt="">
          <h4>暂无报名人员报名情况</h4>
        </h5>
        <el-table v-if="lists && lists.length > 0"
          :data="lists" stripe border
          style="width: 100%" @selection-change="updateSelected">
          <el-table-column
            type="selection"
            width="55" :selectable="checkboxInit">
          </el-table-column>
          <el-table-column type="expand" width="20">
            <template slot-scope="props">
              <div>
                用户ID: <span>{{ props.row.userId }}</span>
              </div>
              <div v-if="props.row.paystateName">
                支付状态: <span>{{ props.row.paystateName }}</span>
              </div>
              <div v-if="props.row.payDate">
                支付时间: <span>{{ props.row.payDate }}</span>
              </div>
              <div v-if="props.row.state">
                报名状态:
                <span v-if="props.row.state == '0'">未确认</span>
                <span v-if="props.row.state == '1'">已确认</span>
                <span v-if="props.row.state == '2'">已拒绝</span>
              </div>
              <div v-if="props.row.type">
                报名类型:
                <span v-if="props.row.type == '01'">线上课程</span>
                <span v-if="props.row.type == '02'">直播</span>
                <span v-if="props.row.type == '03'">计划</span>
                <span v-if="props.row.type == '04'">线下课程</span>
              </div>
              <div v-if="props.row.remarks && props.row.remarks.indexOf('|') > -1">
                <div>
                  是否携带样机: <span>{{(props.row.remarks.split('|')[0] == '1') ? '是' : '否' }}</span>
                </div>
                <div v-if="props.row.remarks.split('|')[0] == '1'">
                  样机型号: <span>{{ props.row.remarks.split('|')[1] }}</span>
                </div>
              </div>
              <div v-else>
                {{ props.row.remarks }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
          label="姓名"
          width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.members">{{scope.row.members[0].name}}</span>
          </template>
        </el-table-column>
          <el-table-column
            label="报名类型"
            width="180">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '01'">线上课程</span>
              <span v-if="scope.row.type == '02'">直播</span>
              <span v-if="scope.row.type == '03'">计划</span>
              <span v-if="scope.row.type == '04'">线下课程</span>
            </template>
          </el-table-column>
          <el-table-column label="报名状态">
            <template slot-scope="scope">
              <span v-if="scope.row.state == '0'">未确认</span>
              <span v-if="scope.row.state == '1'">已确认</span>
              <span v-if="scope.row.state == '2'">已拒绝</span>
            </template>
          </el-table-column>
          <el-table-column label="审核" width="130">
            <template slot-scope="scope">
              <el-button size="mini" icon="el-icon-my-enable" type="text" @click="confirm(scope.row)" v-if="scope.row.state == '0'" :disabled="(scope.row.state !== '0') ? true : false">确认</el-button>
              <el-button size="mini" icon="el-icon-my-disable" type="text" @click="reject(scope.row)" v-if="scope.row.state == '0'" :disabled="(scope.row.state !== '0') ? true : false">拒绝</el-button>
              <span v-if="scope.row.state == '1' || scope.row.state == '2'">{{scope.row.stateName}}</span>
            </template>
          </el-table-column>
          <el-table-column width="40">
            <template slot-scope="scope">
              <a title="删除记录" class="el-icon-delete" @click="del(scope.row.id)" style="cursor: pointer;"></a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="onsite_list_bottom mtf30">
        <div v-if="cntData > 0">共<b>{{cntData}}</b>条报名信息</div>
        <div v-if="cntData > 0">
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </div>
      </div>
      <!--/右侧内容-->
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import Vue from 'vue'
  import Paginate from 'vuejs-paginate'
  import ModalBox from '@/components/common/modal/index.vue'
  import rangeManip from '@/components/byl/rangeManip/withInputs.vue'
  import utils from '@/utils'
  import clonedeep from 'lodash.clonedeep'
  import msgService from '@/utils/sendMsg'
  export default {
    components: { Paginate },
    mounted () {
      this.getModel(this.$route.params.id)
      this.getName(this.$route.params.id)
    },
    data () {
      return {
        filters: {
          pageNo: 1,
          pageSize: 10
        },
        form: {},
        lists: [],
        selected: [],
        cntData: 0,
        pages: 0,
        prefix: this.$route.meta.prefix || ''
      };
    },
    computed: {
    },
    methods: {
      checkboxInit(row,index) {
        if (row.state == '1' || row.state == '2') {//你需要判断的条件
          return 0; //不可勾选
        } else {
          return 1; //可勾选
        }
      },
      clickCallback (pageNum) {
        this.filters.pageNo = pageNum
        this.getModel(this.$route.params.id)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      del (id) {
        if (id) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '该用户的报名记录将被清空, 确认删除这条报名记录吗？',
            yes: function () {
              api.get(config.enrollApiPath, '/signupuser/delete', { id: id }, r => {
                that.$toasted.show('删除成功')
                that.getModel(that.$route.params.id)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      confirm (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '报名确认',
            text: '通过这条报名记录吗？',
            yes: function () {
              api.post(config.enrollApiPath, '/signupuser/audit', {
                ids: item.id,
                state: '1',
                remarks: item.remarks
              }, r => {
                that.$toasted.show('已确认')
                that.getModel(that.$route.params.id)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      reject (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '报名确认',
            text: '拒绝这条报名记录吗？',
            yes: function () {
              api.post(config.enrollApiPath, '/signupuser/audit', {
                ids: item.id,
                state: '2',
                remarks: item.remarks
              }, r => {
                that.$toasted.show('已拒绝')
                that.getModel(that.$route.params.id)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      multiAudit (arr, options) {
        var that = this
        this.confirmBox({
          title: options.title,
          text: options.text,
          yes: function () {
            api.post(config.enrollApiPath, '/signupuser/audit', {
              ids: utils.arr2str(utils.grabVal(arr, 'id')),
              state: options.state
            }, r => {
              that.$toasted.show(options.msg)
              that.getModel(that.$route.params.id)
              that.$modal.hide('dialog')
            })
          }
        })
      },
      getModel (id) {
        var that = this
        api.post(config.enrollApiPath, '/signupuser/search', { signupid: id, noUser: '1', pageNo: this.filters.pageNo, pageSize: this.filters.pageSize }, function (r) { // 正常
          if (r.data) {
            that.lists = r.data
            that.cntData = r.cntData // 总数
            that.pages = Math.ceil(r.cntData / that.filters.pageSize) // 页数
          }else{
            that.lists = []
          }
        })
      },
      getName (id) {
        var that = this
        api.get(config.enrollApiPath, '/signupinfo/get', { id: id }, function (r) { // 正常
          that.form = r.data
        })
      },
      setMsgLists (arr) {
        let newarr = clonedeep(arr)
        for (let i = 0; i < newarr.length; i++) {
          let o = newarr[i]
          o.id = o.members[0].id
          o.name = o.members[0].name
          o.type = '03'
          o.uitype = '02'
        }
        return newarr
      },
      showBox () {
        var that = this
        var list = []
        if (this.selected.length == this.lists.length || this.selected.length == 0) {
          list = this.lists
        } else {
          list = this.selected
        }
        this.$modal.show(ModalBox, {
          opts: {
            title: '发送消息',
            styles: {
              width: '960',
              height: String(0.8242 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'range',
              template: rangeManip,
              inputs: that.setMsgLists(list),
              outputsKey: 'outputs' // 该组件对外输出数据时，定义的key值
            },
            yes (val) { // 点击确认后要做的事情
              if (val.form && val.form.title && val.form.content && val.form.type && val.form.type.length > 0 && val.people && val.people.length > 0) {
                msgService.sendMsg(val).then((r) => {
                  that.$toasted.show('消息已发送')
                })
              }
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
      },
      updateSelected (val) {
        this.selected = val
      }
    }
  }
</script>

<style lang="scss" scoped>
  .xo-table-btn {
    padding: 5px;
    background-color: #ff3633;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  .highlight_title {
    height: 60px;
    line-height: 60px;
    background: #fcca75;
    text-align: center;
    font-weight: normal;
    margin-top: 10px;
    color: #fff;
    font-size: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/enroll/audit.vue